// extracted by mini-css-extract-plugin
module.exports = {"card":"index_card__2Tj_2"};